import { convertMinToDayHourMin } from './convertMinToDayHourMin';

export const valuesConverter = (data: any[]) => {
  return data.map((row) => {
    return {
      ...row,
      slaDurationConverted: convertMinToDayHourMin(
        row.slaDuration,
        row.timeType
      ),
      passed: () => {
        if (row.slaTitle?.includes('Bookin Accuracy'))
          switch (row.eol) {
            case 'OnTime':
              return 'On Time';
            case 'Late':
              return 'Late';
            case 'Early':
              return 'Early';
            default:
              return '';
          }
      },
    };
  });
};
